import { SyntheticEvent } from 'react';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, Text, usePopoverMenu } from '@frontend/design-system';

type PhoneNumberPopoverType = {
  getItemProps: ReturnType<typeof usePopoverMenu>['getItemProps'];
  onClick: (e?: SyntheticEvent, overrideNumber?: string) => void;
  data?: { label: string; number: string }[];
  trackingId?: string | undefined;
};

export const PhoneNumberPopover = ({ data, getItemProps, trackingId, onClick }: PhoneNumberPopoverType) => {
  return (
    <>
      {data?.map(({ label, number }, index) => (
        <div key={`${label}-${number}`}>
          <Text css={{ padding: theme.spacing(0, 2) }} color='light' size='medium'>
            {label}
          </Text>
          <PopoverMenuItem
            {...getItemProps({
              index,
              onClick: (e: SyntheticEvent<Element, Event> | undefined) => {
                onClick(e, number);
              },
            })}
            trackingId={trackingId}
            label={label}
          >
            {formatPhoneNumber(number)}
          </PopoverMenuItem>
        </div>
      ))}
    </>
  );
};
